import React from 'react';
import styles from "./styles/HomepageStatitisticsCard.module.css"
function HomepageStatitisticsCard({title,value,color}) {
    return (
      <>    
        <div className={styles.card_container} style={{backgroundColor:color}}>
          <div className={styles.card} >
          <div className={styles.card_title}>{title}</div>
          <div className={styles.card_info}>{value}</div>
        </div>
      </div>
      </>
    );
}

export default HomepageStatitisticsCard;